<template>
  <svg viewBox="0 0 1024 1024" fill="currentColor">
    <path
      d="M469.5 463h-150c-16.6 0-30-13.4-30-30s13.4-30 30-30h150c16.6 0 30 13.4 30 30s-13.4 30-30 30zM700 583H320c-16.6 0-30-13.4-30-30s13.4-30 30-30h380c16.6 0 30 13.4 30 30s-13.4 30-30 30zM700 703H320c-16.6 0-30-13.4-30-30s13.4-30 30-30h380c16.6 0 30 13.4 30 30s-13.4 30-30 30z"
    />
    <path
      d="M536.1 173l246.1 246.1c5.6 5.6 8.8 13.3 8.8 21.2V823c0 16.6-13.4 30-30 30H261c-16.6 0-30-13.4-30-30V203c0-16.6 13.4-30 30-30h275.1m24.9-60H231c-33.1 0-60 26.9-60 60v680c0 33.1 26.9 60 60 60h560c33.1 0 60-26.9 60-60V403L561 113z"
    />
    <path
      d="M621 257.9l85.1 85.1H621v-85.1M561 113v260c0 16.6 13.4 30 30 30h260L561 113z"
    />
  </svg>
</template>
